import { sanitizeDealPromptFormatAndDevices } from '@openx/components-deal-prompt/lib/utils/filters/sanitizeDealPromptFormatAndDevices.ts';
import type { DealPromptFilters } from '@openx/components-deal-prompt/lib/utils/types.ts';
import { type CriteriaChange, CriteriaDimension } from '@openx/types/tableCriteria.ts';
import { applyCriteriaChange } from '@openx/utils/lib/tableCriteria.ts';
import isEqual from 'lodash/isEqual';
import { useCallback } from 'react';
import { type DefaultTableCriteria, useListCriteria } from '../../../utils/useListCriteria.ts';

export const useDealPromptFilters = () => {
  const { criteria, setCriteria } = useListCriteria('dealPrompt', {
    filters: {},
  } as DefaultTableCriteria<'dealPrompt'>);

  const handleFiltersChange = useCallback(
    (value: DealPromptFilters) => {
      const normalized = sanitizeDealPromptFormatAndDevices(value, criteria.filters);

      const newCriteria: CriteriaChange<CriteriaDimension, DealPromptFilters> = {
        dimension: CriteriaDimension.FILTERS,
        value: normalized,
      };

      const newCriteriaProcessed = applyCriteriaChange(criteria, newCriteria);

      if (!isEqual(newCriteriaProcessed, criteria)) {
        setCriteria(newCriteriaProcessed);
      }
    },
    [criteria, setCriteria]
  );

  return { criteria, handleFiltersChange };
};
